import {
  DisplayFormErrors,
  InputField,
  VerticalForm,
  DebugForm,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "melco-ui";
import { useFormikContext } from "formik";
import { SelectInputFormat } from "./SelectInputFormat";
import { SelectService } from "./SelectService";

type DisplayAddDesignMappingFormModalProps = {
  open: boolean;
  onCancel: () => void;
};
export const DisplayAddDesignMappingFormModal: React.FC<
  DisplayAddDesignMappingFormModalProps
> = ({ open, onCancel }) => {
  const { t } = useTranslation();

  const { handleSubmit, resetForm, isSubmitting } = useFormikContext();

  const handleCancel = () => {
    resetForm();
    onCancel();
  };

  return (
    <Modal
      title={t("designMappings.actions.add.form.title")}
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>
          {t("designMappings.actions.add.form.cancel")}
        </Button>,
        <Button
          type="primary"
          disabled={isSubmitting}
          loading={isSubmitting}
          onClick={() => handleSubmit()}
        >
          {t("designMappings.actions.add.form.submit")}
        </Button>,
      ]}
    >
      <VerticalForm>
        <DisplayFormErrors />

        <InputField
          name="name"
          label={t("designMappings.actions.add.form.label.name")}
        />

        <SelectInputFormat />

        <SelectService />
      </VerticalForm>

      {false && <DebugForm />}
    </Modal>
  );
};
